import request from '@/utils/request'

//获取用户列表
export function getUserList(data){
  return request({
    url:"/api-sp/sp/user/list",
    method:"post",
    data:data,
  })
}


//创建用户
export function createUserApi(data){
  return request({
    url:"/api-sp/sp/user/save",
    method:"post",
    data:data,
  })
}

//修改用户信息
export function updateUserApi(data){
  return request({
    url:"/api-sp/sp/user/update",
    method:"post",
    data:data,
  })
}

//修改密码
export function updatePasswordApi(data){
  return request({
    url:"/api-sp/sp/user/updPassword",
    method:"post",
    data:data,
  })
}

//获取角色
export function getRolesApi(data){
  return request({
    url:"/api-sp/sp/role/getRoles",
    method:"post",
    data:data,
  })
}

//下载文件
export function exportUserApi(data){
  return request({
    url:"/api-sp/sp/user/exportUserInfo",
    method:"post",
    responseType: 'blob',
    data:data,
  })
}